import store from "../store/storeInstance";

export function showSuccess(title, msg, icon) {
  initToast();
  window.iziToast.success({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showError(title, msg, icon) {
  initToast();
  window.iziToast.error({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showWarning(title, msg, icon) {
  initToast();
  window.iziToast.warning({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showInfo(title, msg, icon) {
  initToast();
  window.iziToast.info({
    icon: icon,
    title: title,
    message: msg
  });
}

function initToast() {
  const { settings } = store.getState();
  window.iziToast.settings({
    timeout: settings.isAppMode ? 3000 : 5000,
    resetOnHover: true,
    // icon: '', // icon class
    transitionIn: "flipInX",
    transitionOut: "flipOutX",
      position: settings.isAppMode ? "bottomCenter" : "topCenter", // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
    onOpen: function() {},
    onClose: function() {}
  });
}
